import { render } from "./CIS-Resource-Advisory-RiskCategory.vue?vue&type=template&id=71f19abc"
import script from "./CIS-Resource-Advisory-RiskCategory.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Advisory-RiskCategory.vue?vue&type=script&lang=js"

import "./CIS-Resource-Advisory-RiskCategory.vue?vue&type=style&index=0&id=71f19abc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__